import { gql } from "./api";

interface LoginInput {
  username: String;
  password: String;
}

interface ChangePasswordInput {
    uuid: String;
    password: String;
    otp_token: String | undefined;
}

interface ChangeLanguageInput {
    uuid: String;
    language: String;
    token: String;
}

export const changePassword = async({ uuid, password, otp_token }: ChangePasswordInput) => {
     const response = await gql(
        {
            query: `
                mutation PasswordUpdateUser {
                    passwordUpdateUser(
                        updateUserPasswordInput: { uuid: "${uuid}", password: "${password}", otp_token: "${otp_token}" }
                    ) {
                        uuid
                    }
                }
          `,
          returnFunc: 'passwordUpdateUser'
        }
    );
    return response;
}


export const changeLanguage = async({ uuid, language, token }: ChangeLanguageInput) => {
     const response = await gql(
        {
            query: `
                mutation LanguageUpdateUser {
                    languageUpdateUser(
                        updateUserLanguageInput: { uuid: "${uuid}", lang: "${language}", token: "${token}", user_uuid: "${uuid}" }
                    ) {
                        uuid
                    }
                }
          `,
          returnFunc: 'languageUpdateUser'
        }
    );
    return response;
}

export const LoginAccount = async ({
  username,
  password
}: LoginInput) => {
    const response = await gql(
        {
            query: `
                mutation LoginUser {
                    loginUser(userInput: { email: "${username}", password: "${password}" }) {
                        uuid
                        token
                        email
                        firstname
                        lastname
                        job_title
                        settings
                        organization {
                            name
                            shortname
                        }
                        organization_list
                        organization_count
                        user_count
                    }
                }
          `,
          returnFunc: 'loginUser'
        }
    );

  return response;
};



